import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Footer from './footer';
import Navbars from './Navbar';
import Carousels from './carousel';
 
const ImportDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
 
  const { cbeName, hawbNo, courierName } = location.state || {};
 
  const [cbeDetails, setCbeDetails] = useState(null);
  const [error, setError] = useState(null);
  const [selectedCbeName, setSelectedCbeName] = useState(cbeName);
 
  const displayFields = [
    { fieldKey: 'cbeNo', label: 'CBE No' },
    { fieldKey: 'cbeDate', label: 'CBE Date' },
    { fieldKey: 'assessableValue', label: 'Assessable Value' },
    { fieldKey: 'totalDuty', label: 'Total Duty' },
    { fieldKey: 'status', label: 'Status' },
    { fieldKey: 'detail_description', label: 'Detail Description' },
    { fieldKey: 'modified_date', label: 'Modified Date' },
    { fieldKey: 'hawbNo', label: 'HAWB No' },
    { fieldKey: 'courierName', label: 'Courier Co' },
  ];
 
  useEffect(() => {
    if (!cbeName || !hawbNo || !courierName) return;
 
    const fetchCbeDetails = async () => {
      try {
        const response = await fetch(`/eicimobility/cbeDetails`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cbeName, hawbNo, courierName }),
        });
 
        const data = await response.json();
 
        if (response.ok) {
          setCbeDetails(data);
        } else {
          setError(data.errorMessage || 'Failed to fetch CBE details.');
        }
      } catch (err) {
        setError('Error fetching data.');
      }
    };
 
    fetchCbeDetails();
  }, [cbeName, hawbNo, courierName]);
 
  if (!cbeName || !hawbNo || !courierName) {
    return (
<div className="alert alert-danger text-center mt-5">
        Missing CBE details. Please search again.
</div>
    );
  }
 
  const renderCbeList = () => {
    if (!cbeDetails || !cbeDetails.cbeNoList) return null;
 
    const cbeNoList = cbeDetails.cbeNoList || [];
 
    if (cbeNoList.length === 0) {
      return <div className="alert alert-info text-center">No CBE Numbers available</div>;
    }
 
    return (
<ul className="list-group">
        {cbeNoList.map((cbe, idx) => (
<li
            key={idx}
            className={`list-group-item ${cbe === selectedCbeName ? 'active' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setSelectedCbeName(cbe);
              navigate('/cbeDetails', {
                state: { cbeName: cbe, hawbNo, courierName },
              });
            }}
>
            {cbe}
</li>
        ))}
</ul>
    );
  };
 
  const renderImportDetails = () => {
    if (error) {
      return <div className="alert alert-danger text-center">{error}</div>;
    }
 
    if (!cbeDetails) {
      return <div className="text-center">Loading...</div>;
    }
 
    const { importDetails } = cbeDetails;
    return (
<table className="table table-bordered table-striped table-sm mt-4">
<tbody>
          {displayFields.map(({ fieldKey, label }) => {
            const fieldValue = importDetails?.[fieldKey];
            return fieldValue !== undefined && fieldValue !== null ? (
<tr key={fieldKey}>
<td>{label}</td>
<td>{typeof fieldValue === 'object' ? JSON.stringify(fieldValue) : fieldValue}</td>
</tr>
            ) : null;
          })}
          {cbeDetails.hawbNo && (
<tr key="hawbNo">
<td>HAWB No</td>
<td>{cbeDetails.hawbNo}</td>
</tr>
          )}
          {cbeDetails.courierName && (
<tr key="courierName">
<td>Courier Co</td>
<td>{cbeDetails.courierName}</td>
</tr>
          )}
</tbody>
</table>
    );
  };
 
  return (
<div className="container-fixed">
<Navbars />
<Carousels />
<Container className="mt-4 import-form-carousel">
<h3 className="text-center mb-4">Import</h3>
        {renderCbeList()}
        {renderImportDetails()}
<br />
<button
          type="button"
          className="btn btn-danger submit-btn return-btn"
          onClick={() => navigate('/import')}
>
          RETURN
</button>
</Container>
<Footer />
</div>
  );
};
 
export default ImportDetails;